import { lazy } from "react"
import { IOpenableMissionChest } from "store/apis/openableMissionChestAPI"

export const MISSION_MODALS = {
  missionChestDetails: {
    component: lazy(() => import("modals/ui/mission/MissionChestDetailsModal")),
    params: {} as {
      chest: IOpenableMissionChest
    }
  },
  whitelistInfo: {
    component: lazy(() => import("modals/ui/mission/WhitelistInfoModal")),
    params: {} as {
      availableAt?: string
      onExpire?: () => void
    }
  },
  chestRewardsInfo: {
    component: lazy(() => import("modals/ui/mission/ChestRewardsInfoModal")),
    params: {} as Record<string, never>
  }
} as const
